import { useUser } from "../../../../context";
import nft_product from "../../../../i11/Nft_Product";
import Disclaimer from "../../../Disclaimer";

const Declined = () => {
	const { locale } = useUser();
	return (
		<div className="body1-m">
			<Disclaimer>{nft_product[locale].declined}</Disclaimer>
		</div>
	);
};

export default Declined;
